/**
 *
 * MsTeamsVerify
 *
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Button from 'ui/components/Button';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIsVerify, makeSelectError } from './selectors';
import { verifyMsteams } from './actions';
import reducer from './reducer';
import saga from './saga';
import queryString from 'query-string';
import {
  VerifyContainer,
  VerifyContent,
  VerifyHeaderWrapper,
  VerifyDivider,
  VerifyLogo,
} from './styled';
import insentLogo from 'assets/img/brand/logo.png';
import routeTemplates from 'common/route-templates';
import { NOTIFICATION } from 'common/constants';
import triggerNotification from 'utils/triggerNotification';
import { Helmet } from 'react-helmet';

export const MsTeamsVerify = props => {
  useInjectReducer({ key: 'msTeamsVerify', reducer });
  useInjectSaga({ key: 'msTeamsVerify', saga });

  const { verifyMsteamsStart, isVerify, error, verifyMsteamsError } = props;
  console.log('redirect url', window.location.href);
  const tenantId = queryString.parse(props.location.search).tenant;
  const errorConnection = queryString.parse(props.location.search).error;
  let state, integrationKey;
  if (errorConnection) {
    verifyMsteamsError({ error: 'Something went wrong.Please try again' });
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }
  try {
    state = JSON.parse(decodeURIComponent(queryString.parse(props.location.search).state));
    integrationKey = state && state.integrationKey;
  } catch (e) {
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }

  useEffect(() => {
    if (tenantId && state) {
      verifyMsteamsStart({
        payload: { tenantId, state: JSON.stringify(state), integrationKey },
        metadata: { projectName: state },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);
  return (
    <>
      <Helmet>
        <title>Insent | Verify MS Teams</title>
        <meta name="description" content="Verify your MS Teams" />
      </Helmet>
      <VerifyContainer>
        <div className="d-flex justify-content-center p-5">
          <VerifyLogo src={insentLogo} alt="insent logo" />
          <h1 className="text-center">Insent</h1>
        </div>
        <VerifyContent>
          {isVerify ? (
            <>
              <VerifyHeaderWrapper>Pending</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Verifcation Pending</p>
            </>
          ) : error ? (
            <>
              <VerifyHeaderWrapper>Failed</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Something went wrong while connecting Microsoft Teams with Insent</p>
            </>
          ) : (
            <>
              <VerifyHeaderWrapper>Successful</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Successfully connected your Microsoft Teams with Insent </p>
            </>
          )}
        </VerifyContent>
      </VerifyContainer>
    </>
  );
};
MsTeamsVerify.propTypes = {
  // defaultActionStart: PropTypes.func.isRequired,
};
export const mapStateToProps = (state, props) => {
  // @dev you can pass props to makeSelectFuncs(props) like so.
  return createStructuredSelector({
    isVerify: makeSelectIsVerify(),
    error: makeSelectError(),
  });
};
export const mapDispatchToProps = dispatch => {
  /*
   * @dev - best practices for handling redux action
   * @params {object} payload - handle data to pass to api
   * @params {object} metadata - handle method, properties in redux-saga
   */
  return {
    verifyMsteamsStart: ({ payload, metadata }) =>
      dispatch(verifyMsteams.start({ payload, metadata })),
    verifyMsteamsError: ({ error }) => dispatch(verifyMsteams.error({ error })),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(MsTeamsVerify);
